(function (app) {
    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Root.Policies", {
            url: "/Policies",
            redirectTo: "Root.Policies.List"
        });
    }]);
})(window.app);
